import {
    NOTIFY_CLEAR_ALL,
    NOTIFY_CLEAR_DECISION,
    NOTIFY_DELETE_ALL_FINISH,
    NOTIFY_DELETE_ALL_REQUEST,
    NOTIFY_FETCH_FAIL,
    NOTIFY_FETCH_REQUEST,
    NOTIFY_FETCH_SUCCESS,
    NOTIFY_MARK_ALL_READ,
    NOTIFY_PATCH_ONE,
    NOTIFY_REMOVE_ONE,
    NOTIFY_SET_DECISION,
    NOTIFY_SET_DECISION_LOADING,
    NOTIFY_SET_FILTER,
    NOTIFY_SET_OPEN,
} from "./action/action";



const initialState = {
    items: [],
    filter: "all",
    open: false,

    loading: false,
    refreshing: false,
    initialized: false,
    error: null,
    lastFetchAt: 0,

    deleteAllLoading: false,

    taskDecisionMap: {},
    taskDecisionLoadingMap: {},
};

function patchItemById(items, id, patch) {
    return items.map((item) =>
        item?._id === id
            ? {
                ...item,
                ...patch,
            }
            : item
    );
}

function removeItemById(items, id) {
    return items.filter((item) => item?._id !== id);
}

function keepOnlyExistingKeys(map, items) {
    const idSet = new Set((items || []).map((item) => item?._id).filter(Boolean));
    const next = {};

    Object.keys(map || {}).forEach((key) => {
        if (idSet.has(key)) {
            next[key] = map[key];
        }
    });

    return next;
}

export default function NotifyCenterReducer(state = initialState, action) {
    switch (action.type) {
        case NOTIFY_SET_OPEN:
            return {
                ...state,
                open: Boolean(action.payload),
            };

        case NOTIFY_SET_FILTER:
            return {
                ...state,
                filter: action.payload === "unread" ? "unread" : "all",
            };

        case NOTIFY_FETCH_REQUEST:
            return {
                ...state,
                loading: action.payload?.silent ? false : !state.initialized,
                refreshing: action.payload?.silent ? true : state.initialized,
                error: null,
            };

        case NOTIFY_FETCH_SUCCESS:
            return {
                ...state,
                items: action.payload || [],
                loading: false,
                refreshing: false,
                initialized: true,
                error: null,
                lastFetchAt: Date.now(),
                taskDecisionMap: keepOnlyExistingKeys(
                    state.taskDecisionMap,
                    action.payload || []
                ),
                taskDecisionLoadingMap: keepOnlyExistingKeys(
                    state.taskDecisionLoadingMap,
                    action.payload || []
                ),
            };

        case NOTIFY_FETCH_FAIL:
            return {
                ...state,
                loading: false,
                refreshing: false,
                initialized: true,
                error: action.payload || "Ошибка загрузки уведомлений",
            };

        case NOTIFY_PATCH_ONE:
            return {
                ...state,
                items: patchItemById(
                    state.items,
                    action.payload?.id,
                    action.payload?.patch || {}
                ),
            };

        case NOTIFY_MARK_ALL_READ:
            return {
                ...state,
                items: state.items.map((item) =>
                    item?.unread === true ? { ...item, unread: false, isUnread: false } : item
                ),
            };

        case NOTIFY_REMOVE_ONE: {
            const nextItems = removeItemById(state.items, action.payload);
            return {
                ...state,
                items: nextItems,
                taskDecisionMap: keepOnlyExistingKeys(state.taskDecisionMap, nextItems),
                taskDecisionLoadingMap: keepOnlyExistingKeys(
                    state.taskDecisionLoadingMap,
                    nextItems
                ),
            };
        }

        case NOTIFY_CLEAR_ALL:
            return {
                ...state,
                items: [],
                taskDecisionMap: {},
                taskDecisionLoadingMap: {},
            };

        case NOTIFY_DELETE_ALL_REQUEST:
            return {
                ...state,
                deleteAllLoading: true,
            };

        case NOTIFY_DELETE_ALL_FINISH:
            return {
                ...state,
                deleteAllLoading: false,
            };

        case NOTIFY_SET_DECISION:
            return {
                ...state,
                taskDecisionMap: {
                    ...state.taskDecisionMap,
                    [action.payload?.id]: action.payload?.value,
                },
            };

        case NOTIFY_SET_DECISION_LOADING:
            return {
                ...state,
                taskDecisionLoadingMap: {
                    ...state.taskDecisionLoadingMap,
                    [action.payload?.id]: Boolean(action.payload?.value),
                },
            };

        case NOTIFY_CLEAR_DECISION: {
            const nextDecisionMap = { ...state.taskDecisionMap };
            const nextDecisionLoadingMap = { ...state.taskDecisionLoadingMap };

            delete nextDecisionMap[action.payload];
            delete nextDecisionLoadingMap[action.payload];

            return {
                ...state,
                taskDecisionMap: nextDecisionMap,
                taskDecisionLoadingMap: nextDecisionLoadingMap,
            };
        }

        default:
            return state;
    }
}